// User errors
export const USER_ERRORS_EMAIL_CONFIRMATION_SUCCESS = "EmailConfirmationSuccess";
export const USER_ERRORS_INVALID_LOGIN = "InvalidLogin";
export const USER_ERRORS_NOT_ACCESSIBLE_CUSTOM_PAGE = "NotAccessibleCustomPage";
export const USER_ERRORS_NOT_ACCESSIBLE_DASHBOARD = "NotAccessibleDashboard";
export const USER_ERRORS_NOT_ACCESSIBLE_DATASET = "NotAccessibleDataset";
export const USER_ERRORS_NOT_ACCESSIBLE_NODE = "NotAccessibleNode";

// Managed errors
export const USER_MANAGED_CSV_BAD_DATA = "CsvBadData";

export const getManagedErrorsTranslations = (t, data) => {
  const translations = t => ({
    // User errors
    ConcurrencyFailure: t("errors.user.concurrencyFailure", {...data}),
    DefaultError: t("errors.user.defaultError", {...data}),
    DeleteFilterWithRelationship: t("errors.user.filterWithRelationship", {...data}),
    DuplicateEmail: t("errors.user.duplicateEmail", {...data}),
    DuplicateEmailUnconfirmed: t("errors.user.duplicateEmailUnconfirmed", {...data}),
    DuplicateRoleName: t("errors.user.duplicateRoleName", {...data}),
    DuplicateUserName: t("errors.user.duplicateUsername", {...data}),
    FilterWithRelationship: t("errors.user.filterWithRelationship", {...data}),
    InvalidEmail: t("errors.user.invalidEmail", {...data}),
    InvalidRoleName: t("errors.user.invalidRoleName", {...data}),
    InvalidToken: t("errors.user.invalidToken", {...data}),
    InvalidUserName: t("errors.user.invalidUserName", {...data}),
    LoginAlreadyAssociated: t("errors.user.loginAlreadyAssociated", {...data}),
    PasswordMismatch: t("errors.user.passwordMismatch", {...data}),
    PasswordRequiresDigit: t("errors.user.passwordRequiresDigit", {...data}),
    PasswordRequiresLower: t("errors.user.passwordRequiresLower", {...data}),
    PasswordRequiresNonAlphanumeric: t("errors.user.passwordRequiresNonAlphanumeric", {...data}),
    PasswordRequiresUpper: t("errors.user.passwordRequiresUpper", {...data}),
    PasswordTooShort: t("errors.user.passwordTooShort", {...data}),
    UserAlreadyHasPassword: t("errors.user.userAlreadyHasPassword", {...data}),
    UserAlreadyInRole: t("errors.user.userAlreadyInRole", {...data}),
    UserLockoutNotEnabled: t("errors.user.userLockoutNotEnabled", {...data}),
    UserNotInRole: t("errors.user.userNotInRole", {...data}),
    [USER_ERRORS_EMAIL_CONFIRMATION_SUCCESS]: t("errors.user.emailConfirmationSuccess", {...data}),
    [USER_ERRORS_INVALID_LOGIN]: t("errors.user.invalidLogin", {...data}),
    [USER_ERRORS_NOT_ACCESSIBLE_CUSTOM_PAGE]: t("errors.user.notAccessibleCustomPage", {...data}),
    [USER_ERRORS_NOT_ACCESSIBLE_DASHBOARD]: t("errors.user.notAccessibleDashboard", {...data}),
    [USER_ERRORS_NOT_ACCESSIBLE_DATASET]: t("errors.user.notAccessibleDataset", {...data}),
    [USER_ERRORS_NOT_ACCESSIBLE_NODE]: t("errors.user.notAccessibleNode", {...data}),

    // Managed errors
    AssignCustomPage: t("errors.managed.assignCustomPage", {...data}),
    ContentOfCompressedFileIsNotCsv: t("errors.managed.contentOfCompressedFileIsNotCsv", {...data}),
    ContentOfCompressedFileIsNull: t("errors.managed.contentOfCompressedFileIsNull", {...data}),
    CrossServiceMessageBusError: t("errors.managed.crossServiceMessageBusError", {...data}),
    CsvHeaderDuplicateColumnException: t("errors.managed.csvHeaderDuplicateColumnException", {...data}),
    CsvHeaderEmptyColumnException: t("errors.managed.csvHeaderEmptyColumnException", {...data}),
    CsvReadingError: t("errors.managed.csvReadingError", {...data}),
    DataflowNotFound: t("errors.managed.dataflowNotFound", {...data}),
    DatastoreDeleteDatumError: t("errors.managed.datastoreDeleteDatumError", {...data}),
    DatastoreDeleteMetadatasetError: t("errors.managed.datastoreDeleteMetadatasetError", {...data}),
    DatastoreFileUpload: t("errors.managed.datastoreFileUpload", {...data}),
    DatastoreSupersetDependenciesError: t("errors.managed.datastoreSupersetDependenciesError", {...data}),
    DatastoreSupersetDisabled: t("errors.managed.datastoreSupersetDisabled", {...data}),
    DatastoreSupersetSynchronizeError: t("errors.managed.datastoreSupersetSynchronizeError", {...data}),
    DatumNotFound: t("errors.managed.datumNotFound", {...data}),
    DependencyConflict: t("errors.managed.dependencyConflict", {...data}),
    EmptyCsvFile: t("errors.managed.emptyCsvFile", {...data}),
    EngineNotFound: t("errors.managed.engineNotFound", {...data}),
    EngineNotOfType: t("errors.managed.engineNotOfType", {...data}),
    EngineOperationError: t("errors.managed.engineOperationError", {...data}),
    EngineUsed: t("errors.managed.engineUsed", {...data}),
    EmptyCsvHeaderException: t("errors.managed.emptyCsvHeaderException", {...data}),
    FeatureNotFound: t("errors.managed.featureNotFound", {...data}),
    FeatureOperationError: t("errors.managed.featureOperationError", {...data}),
    FilePreloadNotFound: t("errors.managed.filePreloadNotFound", {...data}),
    FilterNotFound: t("errors.managed.filterNotFound", {...data}),
    FormatCompressedFileNotSupported: t("errors.managed.formatCompressedFileNotSupported", {...data}),
    GeometriesNotFound: t("errors.managed.geometriesNotFound", {...data}),
    GetHubCategoryTree: t("errors.managed.getHubCategoryTree", {...data}),
    GetItemViewSnapshot: t("errors.managed.getItemViewSnapshot", {...data}),
    GetNodeCategoryTree: t("errors.managed.getNodeCategoryTree", {...data}),
    GetStructuredDataDefinitionMissingColumns: t("errors.managed.getStructuredDataDefinitionMissingColumns", {...data}),
    HubNotFound: t("errors.managed.hubNotFound", {...data}),
    InvalidCsvHeader: t("errors.managed.invalidCsvHeader", {...data}),
    ItemContainerNotFound: t("errors.managed.itemContainerNotFound", {...data}),
    LicenseFeatureMissing: t("errors.managed.licenseFeatureMissing", {...data}),
    LicenseMaxDatasetsExceeded: t("errors.managed.licenseMaxDatasetsExceeded", {...data}),
    LicenseMaxNodesExceeded: t("errors.managed.licenseMaxNodesExceeded", {...data}),
    LicenseMaxRecordsExceeded: t("errors.managed.licenseMaxRecordsExceeded", {...data}),
    LicenseSdmxFeatureMissing: t("errors.managed.licenseSdmxFeatureMissing", {...data}),
    ManageShareDashboardOnNodes: t("errors.managed.manageShareDashboardOnNodes", {...data}),
    MetadatasetNotFound: t("errors.managed.metadatasetNotFound", {...data}),
    NodeCodeDuplicate: t("errors.managed.nodeCodeDuplicate", {...data}),
    NodeCodeInvalid: t("errors.managed.nodeCodeInvalid", {...data}),
    NodeNotFound: t("errors.managed.nodeNotFound", {...data}),
    RemoveCustomPageAssociationToHub: t("errors.managed.removeCustomPageAssociationToHub", {...data}),
    RemoveCustomPageAssociationToNode: t("errors.managed.removeCustomPageAssociationToNode", {...data}),
    SchemaConflict: t("errors.managed.schemaConflict", {...data}),
    SetHubCategoryTree: t("errors.managed.setHubCategoryTree", {...data}),
    SetNodeCategoryTree: t("errors.managed.setNodeCategoryTree", {...data}),
    StructuredDataEtlEmptyCsvFile: t("errors.managed.structuredDataEtlEmptyCsvFile", {...data}),
    StructuredDataEtlFileUploadError: t("errors.managed.structuredDataEtlFileUploadError", {...data}),
    StructuredDataEtlResourceFormatUnsupported: t("errors.managed.structuredDataEtlResourceFormatUnsupported", {
      ...data
    }),
    StructuredDataEtlResourceNotFound: t("errors.managed.structuredDataEtlResourceNotFound", {...data}),
    StructuredDataEtlResourceUnsupported: t("errors.managed.structuredDataEtlResourceUnsupported", {...data}),
    StructuredEtlTempTableCreationError: t("errors.managed.structuredEtlTempTableCreationError", {...data}),
    TempTableCreationError: t("errors.managed.tempTableCreationError", {...data}),
    TooManyEntriesInCompressedFile: t("errors.managed.tooManyEntriesInCompressedFile", {...data}),
    [USER_MANAGED_CSV_BAD_DATA]: t("errors.managed.csvBadData", {...data})
  });

  return translations(t !== undefined ? t : str => str);
};
